interface PawTimerProps {
  label: string;
  value: number;
  rotate?: string;
  isLoading?: boolean;
}
import { ImSpinner9 } from "react-icons/im";

export function PawTimer({ label, value, rotate, isLoading }: PawTimerProps) {
  const getLabel = () => {
    switch (label) {
      case "Minutes":
        return (
          <span className="text-xs text-gray-600">
            <span className="md:hidden">Mins</span>
            <span className="hidden md:inline">Minutes</span>
          </span>
        );
      case "Seconds":
        return (
          <span className="text-xs text-gray-600">
            <span className="md:hidden">Secs</span>
            <span className="hidden md:inline">Seconds</span>
          </span>
        );
      case "Milliseconds":
        return (
          <span className="text-xs text-gray-600">
            <span className="md:hidden">Milli Secs</span>
            <span className="hidden md:inline">Milliseconds</span>
          </span>
        );
      default:
        return label;
    }
  };

  return (
    <div className={`relative`}>
      <div
        className={`w-[6.8rem] h-[6.8rem] md:w-40 md:h-40 bg-[url('/paws-left.png')] bg-cover bg-center rounded-full flex items-center justify-center flex-col transform ${
          rotate === "left" && "rotate-45"
        } ${rotate === "right" && "-rotate-45"} relative`}
      >
        <div className="transform text-center w-[4rem] h-[4rem] md:w-20 md:h-20 bg-[url('/paw-back.png')] bg-cover bg-center flex flex-col items-center justify-center">
          <div
            className={`text-xl md:text-3xl font-bold ${
              isLoading ? "animate-pulse" : ""
            }`}
          >
            {isLoading ? (
              <ImSpinner9 className="animate-spin text-slate-500 mb-2" />
            ) : (
              value.toString()
            )}
          </div>
          {getLabel()}
        </div>
      </div>
    </div>
  );
}
